import React from 'react'
import './HeaderIcon.css'
// TODO: for now, limit icons to one of these only; send 'hash' icon if icon name does not match
import { FaCode, FaChartLine, FaChartPie, FaCoffee, FaMagic, FaStarHalfAlt, FaMousePointer } from 'react-icons/fa'

export default class HeaderIcon extends React.PureComponent {
  render () {
    const { icon } = this.props

    switch (icon) {
      case 'FaCode':
        return <FaCode className='fa-icon-title'/>
      case 'FaChartLine':
        return <FaChartLine className='fa-icon-title'/>
      case 'FaChartPie':
        return <FaChartPie className='fa-icon-title'/>
      case 'FaMagic':
        return <FaMagic className='fa-icon-title'/>
      case 'FaCoffee':
        return <FaCoffee className='fa-icon-title'/>
      case 'FaStarHalfAlt':
        return <FaStarHalfAlt className='fa-icon-title'/>
      case 'FaMousePointer':
          return <FaMousePointer className='fa-icon-title'/>
      default:
        return <FaCode className='fa-icon-title'/>
    }
  }
}